import React from "react"
import PropTypes from "prop-types"
import { Button } from "@planningcenter/tapestry-react"

/**
 * Renders an icon button that allows the user to switch between desktop and mobile views.
 * Consumer must supply useState props mobileViewSelected and setMobileViewSelected.
 */
const MobileViewSelector = ({ mobileViewSelected, setMobileViewSelected, className }) => {
  return (
    <Button
      className={className}
      variant="outline"
      icon={{ name: mobileViewSelected ? "general.viewTable" : "general.viewCardStack" }}
      tooltip={{ title: mobileViewSelected ? "Switch to Card View" : "Switch to Table View" }}
      onClick={() => setMobileViewSelected(!mobileViewSelected)}
    />
  )
}

MobileViewSelector.propTypes = {
  mobileViewSelected: PropTypes.bool,
  setMobileViewSelected: PropTypes.func,
  className: PropTypes.string
}

export default MobileViewSelector
